module.exports = __webpack_public_path__ + "media/src/images/apple-icon-120x120-14456009f448b2f6678339c9d62c8e55.png";